import { render, staticRenderFns } from "./LegacyListArticle.vue?vue&type=template&id=a07a1302&scoped=true"
import script from "./LegacyListArticle.vue?vue&type=script&setup=true&lang=ts"
export * from "./LegacyListArticle.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./LegacyListArticle.vue?vue&type=style&index=0&id=a07a1302&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a07a1302",
  null
  
)

export default component.exports